import { render, staticRenderFns } from "./submit.vue?vue&type=template&id=51d1142a&scoped=true&"
import script from "./submit.vue?vue&type=script&lang=ts&"
export * from "./submit.vue?vue&type=script&lang=ts&"
import style0 from "./submit.vue?vue&type=style&index=0&id=51d1142a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d1142a",
  null
  
)

export default component.exports